// extracted by mini-css-extract-plugin
module.exports = {"input":"UserStatus_input__1yaz5","status":"UserStatus_status__uox-v","pencil":"UserStatus_pencil__ZgZTY"};